import { render, staticRenderFns } from "./ProfilePhonePage.vue?vue&type=template&id=ab3fc03a&scoped=true&"
import script from "./ProfilePhonePage.vue?vue&type=script&lang=js&"
export * from "./ProfilePhonePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3fc03a",
  null
  
)

export default component.exports